import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar, faAward } from "@fortawesome/free-solid-svg-icons";
import useDatabase from "../../hooks/useDatabase";
import "./SpecialtySandwiches.css";

// Import placeholder image to use for all sandwiches
import placeholderImg from '../../assets/images/PlaceholderImage.jpg';

const SpecialtySandwiches = () => {
  const [sandwiches, setSandwiches] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  // Load sandwiches from database
  const { isLoading: dbLoading, getAllSpecialtySandwiches } = useDatabase();
  
  useEffect(() => {
    const fetchSandwiches = async () => {
      try {
        if (!dbLoading) {
          // Get sandwiches from database
          const specialtySandwiches = getAllSpecialtySandwiches();
          
          // Add images to each sandwich
          const sandwichesWithImages = specialtySandwiches.map(sandwich => ({
            ...sandwich,
            image: placeholderImg,
            imageAlt: `${sandwich.name} sandwich`
          }));
          
          setSandwiches(sandwichesWithImages);
          setIsLoading(false);
        }
      } catch (error) {
        console.error("Error loading specialty sandwiches:", error);
        setIsLoading(false);
      }
    };

    fetchSandwiches();
  }, [dbLoading, getAllSpecialtySandwiches]);

  if (isLoading) {
    return (
      <div className="loading-spinner">
        <FontAwesomeIcon icon={faStar} spin />
        <span>Loading specialty sandwiches...</span>
      </div>
    );
  }

  return (
    <div>      
      <div className="menu-grid">
        {sandwiches.map((sandwich) => (
          <div key={sandwich.id} className="menu-item">
            <div className="sandwich-image-container">
              <img 
                src={sandwich.image} 
                alt={sandwich.imageAlt || sandwich.name}
                className="sandwich-image"
              />
            </div>
            <div className="menu-item-header">
              <h3>{sandwich.name}</h3>
              <div className="price">{sandwich.price}</div>
            </div>
            <p className="description">{sandwich.description}</p>
            {sandwich.badge && (
              <div className="badge">
                {sandwich.featured ? (
                  <FontAwesomeIcon icon={faAward} />
                ) : (
                  <FontAwesomeIcon icon={faStar} />
                )}{" "}
                {sandwich.badge}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default SpecialtySandwiches;
